// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fW","catalogByServiceItem__title":"c-k_fX"};